export const maxPfFileSizeInBytes = 3000000;
export const msWordFormat = 'application/msword';
export const officeDocumentFormat = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
